import React from 'react'
import {Icon} from '@chakra-ui/react'

const SupportIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M22.5923 16.3682V11.7845C22.5923 5.83966 17.7527 1 11.8078 1C5.86292 1 1.01163 5.83966 1.01163 11.7962V16.3799C1.01163 17.3687 1.60496 16.6242 2.6869 16.6242L2.76834 10.7956L2.81487 10.4932C3.45473 6.04906 7.31715 2.6869 11.8194 2.6869C16.3217 2.6869 20.1841 6.03743 20.824 10.4932L20.8705 10.7956C20.8705 10.7956 20.9868 18.5321 20.9868 16.2403C20.9868 16.2403 22.6156 17.3571 22.6156 16.3799L22.5923 16.3682Z"
                fill="currentColor"
            />
            <path
                d="M4.55994 11.2726C4.74608 11.2726 4.88569 11.4239 4.88569 11.5984V17.8225C4.88569 18.0086 4.73445 18.1482 4.55994 18.1482H2.7567C1.7911 18.1482 1 17.3571 1 16.3915V11.5984C1 11.4122 1.15124 11.2726 1.32575 11.2726H4.55994Z"
                fill="currentColor"
            />
            <path
                d="M20.8356 18.1482H19.0324C18.8462 18.1482 18.7066 17.997 18.7066 17.8225V11.5984C18.7066 11.4122 18.8579 11.2726 19.0324 11.2726H22.2549C22.4411 11.2726 22.5807 11.4239 22.5807 11.5984V16.3915C22.5807 17.3571 21.7896 18.1482 20.824 18.1482H20.8356Z"
                fill="currentColor"
            />
            <path
                d="M13.3551 21.3708H10.2489C10.069 21.3708 9.92312 21.5166 9.92312 21.6965V23.6743C9.92312 23.8542 10.069 24 10.2489 24H13.3551C13.535 24 13.6808 23.8542 13.6808 23.6743V21.6965C13.6808 21.5166 13.535 21.3708 13.3551 21.3708Z"
                fill="currentColor"
            />
            <path
                d="M18.8695 19.3698C17.8108 21.7896 15.6702 21.9176 12.9944 21.7896C12.6222 21.7663 12.2731 21.7547 11.959 21.7547C11.4471 21.7547 11.0283 22.1735 11.0283 22.6854C11.0283 23.1973 11.4471 23.6161 11.959 23.6161C12.2382 23.6161 12.564 23.6277 12.9014 23.651C13.3202 23.6743 13.7855 23.6975 14.2858 23.6975C16.6358 23.6975 19.6024 23.1856 20.8472 19.5094C20.8589 19.4628 20.8472 19.4163 20.8589 19.3698H18.8695Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SupportIcon
